/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Item',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Start customization--------------------------------------------
            let productData = element.getParams().props.product; // Get product data here
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            let productItem = document.querySelector('[data-product-id="' + productId + '"]'); // Get product item element
            if (productItem) {
              /* Use pure js here to modify product item element*/
              // Start example: Add product type below product title
              let productTypeHTML = `<div class="boost__sd-product-type">${productData.product_type}</div>`;
              if (!productItem.querySelector('.boost__sd-product-type')) { // Check if productTypeHTML already exists
                productItem.querySelector('.boost-sd__product-title').insertAdjacentHTML('afterend', productTypeHTML);
              }
             // End example.
            }
            // End-------------------------------------------------------------
          } catch (e) {
            console.error(e);
          }
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);